import * as React from "react";

function TaxBenefits() {
  return (
    <div 
      className="tw-box-border tw-flex tw-relative tw-flex-col tw-shrink-0 tw-py-20 md:tw-py-48 tw-px-4 tw-bg-dark-green tw-text-white"
      role="region"
      aria-label="Tax Benefits Section"
    >
      <h1 
        className="tw-self-center tw-mt-14 tw-text-6xl tw-leading-tight tw-text-center tw-text-neutral-800 max-md:tw-mt-10 max-md:tw-text-4xl" 
        aria-label="Tax Benefits"
      >
        Tax Benefits
      </h1>
      <p 
        className="tw-self-center tw-mt-6 tw-text-2xl tw-leading-8 tw-text-center tw-text-neutral-800 max-md:tw-max-w-full"
        style={{ maxWidth: '770px' }}
        aria-label="Tax benefits description"
      >
        Product and monetary donations are entitled to a tax deduction, according to Federal law. The Internal Revenue Service requires that all charitable donations be itemized and valued. Solvy will provide a donation receipt to donor and brand partners.
      </p>
    </div>
  );
}

export default TaxBenefits;